import { useState } from "react";
import { Tag, Check, X } from "lucide-react";
import api from "../lib/api";

export function PromoField({ productId, bundleId, promo, setPromo }) {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const apply = async () => {
    if (!code.trim()) return;
    setBusy(true); setError("");
    try {
      const r = await api.post("/promo/validate", { code, product_id: productId, bundle_id: bundleId });
      if (r.data.valid) { setPromo(r.data); setCode(""); } else { setError(r.data.reason); setPromo(null); }
    } catch (e) { setError(e?.response?.data?.detail || "Could not check code"); }
    finally { setBusy(false); }
  };

  if (promo) {
    return (
      <div className="mt-6 flex items-center justify-between bg-[#0a192f] text-white px-4 py-3" data-testid="promo-applied">
        <div className="inline-flex items-center gap-2 text-sm"><Check className="w-4 h-4 text-[#d4af37]" /> Code <strong data-testid="promo-code-label">{promo.code}</strong> applied — you save <strong>${(promo.discount_cents / 100).toFixed(2)}</strong></div>
        <button data-testid="promo-remove" onClick={() => setPromo(null)} className="text-white/70 hover:text-white"><X className="w-4 h-4" /></button>
      </div>
    );
  }
  return (
    <div className="mt-6" data-testid="promo-field">
      <label className="overline text-[#4a4a4a] inline-flex items-center gap-2"><Tag className="w-3.5 h-3.5 text-[#d4af37]" /> Promo code</label>
      <div className="mt-2 flex gap-2">
        <input data-testid="promo-input" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} onKeyDown={(e) => e.key === "Enter" && apply()} placeholder="WELCOME10" className="flex-1 border border-[#e5e5e5] bg-white px-4 py-3 outline-none focus:border-[#0a192f] uppercase tracking-widest" />
        <button data-testid="promo-apply" type="button" onClick={apply} disabled={busy || !code} className="btn-ghost disabled:opacity-50">{busy ? "…" : "Apply"}</button>
      </div>
      {error && <p data-testid="promo-error" className="text-sm text-red-700 mt-2">{error}</p>}
    </div>
  );
}

export function PriceWithPromo({ cents, promo, testId }) {
  if (!promo) return <span data-testid={testId}>${(cents / 100).toFixed(2)}</span>;
  return (
    <span data-testid={testId}>
      <span className="line-through text-[#4a4a4a] text-2xl mr-3">${(cents / 100).toFixed(2)}</span>
      <span data-testid={`${testId}-final`}>${(promo.final_cents / 100).toFixed(2)}</span>
    </span>
  );
}
